// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as StoreFx__Pause from "./pause.jsx";
import * as StoreFx__Play from "./play.jsx";

function make(param) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const state = param.store.getState();
    if (state.player.paused) {
      return StoreFx__Play.make(undefined);
    } else {
      return StoreFx__Pause.make(undefined);
    }
  }));
}

export {
  make,
}
/* StoreFx__Pause Not a pure module */
